import { render, staticRenderFns } from "./Update3PLAWBModal.vue?vue&type=template&id=5bd7e388"
import script from "./Update3PLAWBModal.vue?vue&type=script&lang=js"
export * from "./Update3PLAWBModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports